// client/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { firebaseConfig } from "./firebase.config";

// Config is now imported from firebase.config.js
// Environment is controlled by REACT_APP_FIREBASE_ENV

// ✅ Initialize Firebase App
const app = initializeApp(firebaseConfig);

// ✅ Firestore and Auth
const db = getFirestore(app);
const auth = getAuth(app);

// ✅ Firebase Functions
const functions = getFunctions(app);

// ✅ Set local persistence (keep session across tabs & reloads)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("⚠️ Error setting auth persistence:", error);
});

export { db, auth, functions };